export const variant1 = 'variant1';
export const variant2 = 'variant2';
export const variant3 = 'variant3';
export const variant4 = 'variant4';

export const ALIGN_CENTER = 'center';
export const ZERO = 'zero';
export const NUMBER_OF_CARDS = 4;
